import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const uploadImage = async (file) => {
  const fd = new FormData();
  fd.append('file', file);
  const { data } = await api.post('/upload-image', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data; // { id, image_url }
};

export const saveToken = async (payload) => {
  const { data } = await api.post('/tokens', payload);
  return data;
};

export const fetchTokens = async () => {
  const { data } = await api.get('/tokens');
  return data;
};

export const absoluteImageUrl = (imgUrl) => {
  if (!imgUrl) return null;
  if (imgUrl.startsWith('http')) return imgUrl;
  return `${BACKEND_URL}${imgUrl}`;
};
